module.exports = __webpack_public_path__ + "static/retail-eb6f7ff63ddb1c1a8d6c76cfea128aff.jpg";